import React, { useState, useEffect, useRef } from "react";
import "../style/moduleSection.css";
import TemplateModal from "./treatmentTemplate";
import parse from "html-react-parser";
import { useAuth } from "../context/authContext";
import Dropdown from "react-bootstrap/Dropdown";

const ModuleSection = ({
  moduleName,
  customValues,
  onChange,
  onTemplatesChange,
  usingGlobalQueue,
  hideMedication,
  globalLovRestriction,
}) => {
  const { authData } = useAuth();
  const showsTreatmentTemplates =
    moduleName === "Physiotherapy Module" ||
    moduleName === "Wound Care Module";
  const showsPlanTemplates = moduleName === "Physiotherapy Module";
  const isMedicationsOnly = moduleName === "Dental Module";
  const [examTemplates, setExamTemplates] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [planTemplates, setPlanTemplates] = useState([]);
  const [treatmentTemplates, setTreatmentTemplates] = useState([]);
  const [templateType, setTemplateType] = useState("treatment");
 

  console.log("treatemetemplates", treatmentTemplates);
  const dropdownRef = useRef(null);

  // Use local state for form inputs
  const [localValues, setLocalValues] = useState({
    queues: "",
    diagnosis: "",
    treatments: "",
    medications: "",
    diagnosisRestriction: false,
    treatmentsRestriction: false,
    medicationsRestriction: false,
  });
// at the top of ModuleSection (before the return)
const autoResize = e => {
  e.target.style.height = 'auto';                // reset
  e.target.style.height = e.target.scrollHeight + 'px';
};
  const moduleKeyMap = {
    "General Surgery Module": "generalSurgery",
    "In Patient Module": "inPatient",
    "Labor & Delivery Module": "laborDelivery",
    "Orthopedic Module": "orthopedic",
    "Pediatric Module": "pediatric",
    "Physiotherapy Module": "physiotherapy",
   "Antenatal Module":  "antenatal", 
    "Primary Care Module": "primaryCare",
    "Dental Module": "dentalVisit",
    "Cleft Lip & Palate Module": "cleftLip",
    "Wound Care Module": "woundCare",
  };
   // Map fields to corresponding customValues keys
const moduleFieldKeyMap = {
  primaryCare: {
    queues:      "primaryCareQueues",
    diagnosis:   "primaryCareDiagnosis",
    treatments:  "primaryCareTreatments",
    medications: "primaryCareDrugs",
    diagnosisRestriction:   "primaryCareDiagnosisRestriction",
    treatmentsRestriction:  "primaryCareTreatmentsRestriction",
    medicationsRestriction: "primaryCareDrugsRestriction",
  },
  dentalVisit: {
    medications: "dentalVisitDrugs",
    medicationsRestriction: "dentalVisitDrugsRestriction",
  },
  orthopedic: {
    queues:      "orthopedicQueues",
    diagnosis:   "orthopedicDiagnosis",
    treatments:  "orthopedicTreatments",
    medications: "orthopedicDrugs",
    diagnosisRestriction:   "orthopedicDiagnosisRestriction",
    treatmentsRestriction:  "orthopedicTreatmentsRestriction",
    medicationsRestriction: "orthopedicDrugsRestriction",
  },
  pediatric: {
    queues:      "pediatricQueues",
    diagnosis:   "pediatricDiagnoses",
    treatments:  "pediatricTreatments",
    medications: "pediatricDrugs",
    diagnosisRestriction:   "pediatricDiagnosesRestriction",
    treatmentsRestriction:  "pediatricTreatmentsRestriction",
    medicationsRestriction: "pediatricDrugsRestriction",
  },
  generalSurgery: {
    queues:      "generalSurgeryQueues",
    diagnosis:   "generalSurgeryDiagnoses",
    treatments:  "generalSurgeryTreatments",
    medications: "generalSurgeryDrugs",
    diagnosisRestriction:   "generalSurgeryDiagnosesRestriction",
    treatmentsRestriction:  "generalSurgeryTreatmentsRestriction",
    medicationsRestriction: "generalSurgeryDrugsRestriction",
  },
  inPatient: {
    queues:      "inPatientQueues",
    diagnosis:   "inPatientNotesDiagnoses",
    treatments:  "inPatientTreatmentTypes",
    medications: "inPatientDrugs",
    diagnosisRestriction:   "inPatientNotesDiagnosesRestriction",
    treatmentsRestriction:  "inPatientTreatmentTypesRestriction",
    medicationsRestriction: "inPatientDrugsRestriction",
  },
  cleftLip: {
    queues:      "cleftLipQueues",
    diagnosis:   "cleftLipDiagnoses",
    treatments:  "cleftLipTreatments",
    medications: "cleftLipDrugs",
    diagnosisRestriction:   "cleftLipDiagnosesRestriction",
    treatmentsRestriction:  "cleftLipTreatmentsRestriction",
    medicationsRestriction: "cleftLipDrugsRestriction",
  },
  laborDelivery: {
    queues:      "laborDeliveryQueues",
    diagnosis:   "laborDeliveryDiagnoses",
    treatments:  "laborDeliveryTreatments",
    medications: "laborDeliveryDrugs",
    diagnosisRestriction:   "laborDeliveryDiagnosesRestriction",
    treatmentsRestriction:  "laborDeliveryTreatmentsRestriction",
    medicationsRestriction: "laborDeliveryDrugsRestriction",
  },
  physiotherapy: {
    queues:      "physiotherapyQueues",
    diagnosis:   "physiotherapyDiagnoses",
    treatments:  "physiotherapyTreatments",
    medications: "physiotherapyDrugs",
    diagnosisRestriction:   "physiotherapyDiagnosesRestriction",
    treatmentsRestriction:  "physiotherapyTreatmentsRestriction",
    medicationsRestriction: "physiotherapyDrugsRestriction",
  },
  antenatal: {
    queues:      "antenatalQueues",
    diagnosis:   "antenatalDiagnoses",
    treatments:  "antenatalTreatments",
    medications: "antenatalDrugs",
    diagnosisRestriction:   "antenatalDiagnosesRestriction",
    treatmentsRestriction:  "antenatalTreatmentsRestriction",
    medicationsRestriction: "antenatalDrugsRestriction",
  },
  woundCare: {
    queues:      "woundCareQueues",
    diagnosis:   "woundCareDiagnoses",
    treatments:  "woundCareTreatments",
    medications: "woundCareDrugs",
    diagnosisRestriction:   "woundCareDiagnosesRestriction",
    treatmentsRestriction:  "woundCareTreatmentsRestriction",
    medicationsRestriction: "woundCareDrugsRestriction",
  },
};
  
  const moduleKey = moduleKeyMap[moduleName];

  const capitalize = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : "");

  // Function to transform customValues keys (remove moduleName prefix)
  const transformCustomValues = (customValues) => {
    const transformed = {};
    for (const key in customValues) {
      if (key.includes("Module")) {
        // Remove the moduleName prefix (e.g., "General Surgery Module")
        const newKey = key.split("Module")[1];
        transformed[newKey] = customValues[key];
      } else {
        // Keep the key as is (e.g., "globalQueue")
        transformed[key] = customValues[key];
      }
    }
    return transformed;
  };

  
  // Function to handle local state updates
  const handleLocalChange = (field, value) => {
    const updatedLocalValues = {
      ...localValues,
      [field]: value,
    };

    // Update local state
    setLocalValues(updatedLocalValues);

   


    // Get the correct key for the field
   const keys = moduleFieldKeyMap[moduleKey];
 const key  = keys[field];
    // Propagate changes back to the parent component
    if (onChange && typeof onChange === "function" && key) {
      onChange(key, value);
    }
  };

  const openModal = (type) => {
    setTemplateType(type);
    setIsModalOpen(true);
  };// Initialize local state from props only once
  useEffect(() => {
    if (customValues) {
      // Transform customValues keys to remove moduleName prefix
      const transformedCustomValues = transformCustomValues(customValues);
const keys = moduleFieldKeyMap[moduleKey];
 setLocalValues({
    queues:      keys.queues ? (transformedCustomValues[keys.queues] || "") : "",
    diagnosis:   keys.diagnosis ? (transformedCustomValues[keys.diagnosis] || "") : "",
    treatments:  keys.treatments ? (transformedCustomValues[keys.treatments] || "") : "",
    medications: keys.medications ? (transformedCustomValues[keys.medications] || "") : "",
    diagnosisRestriction:   keys.diagnosisRestriction ? (transformedCustomValues[keys.diagnosisRestriction] || false) : false,
    treatmentsRestriction:  keys.treatmentsRestriction ? (transformedCustomValues[keys.treatmentsRestriction] || false) : false,
    medicationsRestriction: keys.medicationsRestriction ? (transformedCustomValues[keys.medicationsRestriction] || false) : false,
  });
      // Module-specific template storage to prevent cross-module bleed.
      // Backwards-compatible fallback to legacy global keys.
      const treatmentKey = `${moduleKey}TreatmentTemplateData`;
      const legacyTreatmentKey = "treatmentTemplateData";
      const treatmentData =
        transformedCustomValues[treatmentKey] ??
        transformedCustomValues[legacyTreatmentKey] ??
        [];
      setTreatmentTemplates(Array.isArray(treatmentData) ? treatmentData : []);

      // Set plan templates if they exist
      const planKey = `${moduleKey}PlanTemplateData`;
      const legacyPlanKey = "planTemplateData";
      const planData =
        transformedCustomValues[planKey] ??
        transformedCustomValues[legacyPlanKey] ??
        [];
      setPlanTemplates(Array.isArray(planData) ? planData : []);
    }
  }, [moduleKey, customValues]); // Reinitialize if moduleKey or customValues changes


  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedTemplate(null);
    setTemplateType("treatment");
  };

  // Create a custom dropdown item that forces the dropdown to close
  const CustomDropdownItem = ({ onClick, children }) => {
    return (
      <Dropdown.Item
        onClick={(e) => {
          setOpenDropdown(null); // Close dropdown first
          // Small delay to ensure UI updates before action
          setTimeout(() => {
            onClick(e);
          }, 10);
        }}
      >
        {children}
      </Dropdown.Item>
    );
  };

  const editTemplate = (template, type) => {
    setSelectedTemplate(template);
    setTemplateType(type);
    setIsModalOpen(true);
  };
 
  
  const handleSaveTemplate = (templateType, templateName, templateDetails) => {
    const newTemplate = { templateName, templateDetails };

    const updateTemplates = (prevTemplates, type) => {
      const updatedTemplates = selectedTemplate
        ? prevTemplates.map((t) =>
            t.templateName === selectedTemplate.templateName ? newTemplate : t
          )
        : [...prevTemplates, newTemplate];

      // Update local state
      if (type === "treatment") {
        setTreatmentTemplates(updatedTemplates);
      } else if (type === "plan") {
        setPlanTemplates(updatedTemplates);
      } else {
        setExamTemplates(updatedTemplates);
      }

      // Propagate back to parent
      onTemplatesChange(moduleKey, type, updatedTemplates);
    };

    if (templateType === "treatment") {
      updateTemplates(treatmentTemplates, "treatment");
    } else if (templateType === "plan") {
      updateTemplates(planTemplates, "plan");
    } else if (templateType === "undefined") {
      updateTemplates(examTemplates, "undefined");
    }

    closeModal();
  };

  const deleteTemplate = (index, templateType) => {
    if (templateType === "treatment") {
      const updated = treatmentTemplates.filter((_, i) => i !== index);
      setTreatmentTemplates(updated);
      onTemplatesChange(moduleKey, "treatment", updated);
    } else if (templateType === "plan") {
      const updated = planTemplates.filter((_, i) => i !== index);
      setPlanTemplates(updated);
      onTemplatesChange(moduleKey, "plan", updated);
    } else {
      const updated = examTemplates.filter((_, i) => i !== index);
      setExamTemplates(updated);
      onTemplatesChange(moduleKey, "undefined", updated);
    }
  };
  
  const renderFormattedText = (html) => {
    return parse(html);
  };

  return (
    <div className="module-section">
      <h3>{moduleName}</h3>

      {!isMedicationsOnly && (
        <>
          <div className="form-group">
            <label>Queues</label>
            <textarea
              name={`${moduleKey}Queues`}
              value={localValues.queues}
              onChange={(e) => handleLocalChange("queues", e.target.value)}
              disabled={usingGlobalQueue}
            />
          </div>

          {!usingGlobalQueue && localValues.queues && (
            <p style={{ color: "red", marginTop: "8px", marginLeft: "14%" }}>
              Warning: Any patients currently in the previous Queues will be removed
              if Global Queues enabled.
            </p>
          )}

          <div className="form-group">
            <label>Diagnosis</label>
            <div className="field-with-restriction">
              <textarea
                name={`${moduleKey}Diagnosis`}
                value={localValues.diagnosis}
                onChange={(e) => handleLocalChange("diagnosis", e.target.value)}
              />
              <div className="restriction-checkbox">
                <label>
                  <input
                    type="checkbox"
                    checked={globalLovRestriction || localValues.diagnosisRestriction}
                    onChange={(e) => handleLocalChange("diagnosisRestriction", e.target.checked)}
                    disabled={globalLovRestriction}
                  />
                  <span style={{ marginLeft: "8px" }}>Users must select from drop down list ONLY</span>
                </label>
                <p className="restriction-info">
                  Enable if you want to restrict users from typing in their own value that is not in the list of values within the drop down for this field.
                </p>
              </div>
            </div>
          </div>

          <div className="form-group">
            <label>Treatments</label>
            <div className="field-with-restriction">
              <textarea
                name={`${moduleKey}Treatments`}
                value={localValues.treatments}
                onChange={(e) => handleLocalChange("treatments", e.target.value)}
              />
              <div className="restriction-checkbox">
                <label>
                  <input
                    type="checkbox"
                    checked={globalLovRestriction || localValues.treatmentsRestriction}
                    onChange={(e) => handleLocalChange("treatmentsRestriction", e.target.checked)}
                    disabled={globalLovRestriction}
                  />
                  <span style={{ marginLeft: "8px" }}>Users must select from drop down list ONLY</span>
                </label>
                <p className="restriction-info">
                  Enable if you want to restrict users from typing in their own value that is not in the list of values within the drop down for this field.
                </p>
              </div>
            </div>
          </div>
        </>
      )}

     {(!hideMedication || isMedicationsOnly) && (
  <div className="form-group">
    <label>Medications</label>
    <div className="field-with-restriction">
      <textarea
        name={`${moduleKey}Drugs`}
        value={localValues.medications}
        onChange={(e) => handleLocalChange("medications", e.target.value)}
      />
      <div className="restriction-checkbox">
        <label>
          <input
            type="checkbox"
            checked={globalLovRestriction || localValues.medicationsRestriction}
            onChange={(e) => handleLocalChange("medicationsRestriction", e.target.checked)}
            disabled={globalLovRestriction}
          />
          <span style={{ marginLeft: "8px" }}>Users must select from drop down list ONLY</span>
        </label>
        <p className="restriction-info">
          Enable if you want to restrict users from typing in their own value that is not in the list of values within the drop down for this field.
        </p>
      </div>
    </div>
  </div>
)}


      {showsTreatmentTemplates && (
        <div className="row">
          <div className="col-9">
            <p className="template-description">
              <b>Treatment Note Templates</b> will auto-populate the Treatment
              Note across any module based on the Template selected.
            </p>
          </div>
          <div className="col-9">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th style={{ width: "50%", verticalAlign: "middle" }}>
                    Template Name
                  </th>
                  <th style={{ width: "70%", verticalAlign: "middle" }}>
                    <div className="th-content">
                      <span>Template Details</span>
                      <button
                        style={{ marginLeft: "550px" }}
                        className="btn btn-primary add-template-btn"
                        onClick={() => openModal("treatment")}
                      >
                        + Add Template
                      </button>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {treatmentTemplates.map((template, index) => (
                  <tr key={index}>
                    <td>{template.templateName}</td>
                    <td className="table-cell">
                      <span className="truncated-text">
                        {renderFormattedText(template.templateDetails)}
                      </span>
                      <div className="dropdown">
                        <button
                          className="dropdown-toggle"
                          type="button"
                          onClick={() =>
                            setOpenDropdown(
                              openDropdown === `treatment-${index}`
                                ? null
                                : `treatment-${index}`
                            )
                          }
                        >
                          &#9662;
                        </button>
                        {openDropdown === `treatment-${index}` && (
                          <div className="dropdown-menu show">
                            <button
                              className="dropdown-item"
                              onClick={() => {
                                setSelectedTemplate(template);
                                setTemplateType("treatment");
                                setIsModalOpen(true);
                                setOpenDropdown(null);
                              }}
                            >
                              Edit
                            </button>
                            <button
                              className="dropdown-item"
                              onClick={() => {
                                setTimeout(() => {
                                  if (
                                    window.confirm(
                                      "Are you sure you want to delete this entry?"
                                    )
                                  ) {
                                    deleteTemplate(index, "treatment");
                                  }
                                }, 0);
                                setOpenDropdown(null);
                              }}
                            >
                              Delete
                            </button>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {showsPlanTemplates && (
        <div className="row">
          <div className="col-9">
            <p className="template-description">
              <b>Plan Note Templates</b> will auto-populate the Plan Note
              across any module based on the Template selected.
            </p>
          </div>
          <div className="col-9">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th style={{ width: "50%", verticalAlign: "middle" }}>
                    Template Name
                  </th>
                  <th style={{ width: "70%", verticalAlign: "middle" }}>
                    <div className="th-content">
                      <span>Template Details</span>
                      <button
                        style={{ marginLeft: "550px" }}
                        className="btn btn-primary add-template-btn"
                        onClick={() => openModal("plan")}
                      >
                        + Add Template
                      </button>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {planTemplates.map((template, index) => (
                  <tr key={index}>
                    <td>{template.templateName}</td>
                    <td className="table-cell">
                      <span className="truncated-text">
                        {renderFormattedText(template.templateDetails)}
                      </span>
                      <div className="dropdown">
                        <button
                          className="dropdown-toggle"
                          type="button"
                          onClick={() =>
                            setOpenDropdown(
                              openDropdown === `plan-${index}`
                                ? null
                                : `plan-${index}`
                            )
                          }
                        >
                          &#9662;
                        </button>
                        {openDropdown === `plan-${index}` && (
                          <div className="dropdown-menu show">
                            <button
                              className="dropdown-item"
                              onClick={() => {
                                setSelectedTemplate(template);
                                setTemplateType("plan");
                                setIsModalOpen(true);
                                setOpenDropdown(null);
                              }}
                            >
                              Edit
                            </button>
                            <button
                              className="dropdown-item"
                              onClick={() => {
                                setTimeout(() => {
                                  if (
                                    window.confirm(
                                      "Are you sure you want to delete this entry?"
                                    )
                                  ) {
                                    deleteTemplate(index, "plan");
                                  }
                                }, 0);
                                setOpenDropdown(null);
                              }}
                            >
                              Delete
                            </button>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {isModalOpen && (
        <TemplateModal
          onSave={handleSaveTemplate}
          onClose={closeModal}
          selectedTemplate={selectedTemplate}
          templateType={templateType}
        />
      )}
    

    </div>
  );
};

export default ModuleSection;
